<script setup>
import { htmlPurify } from "~/lib/utils";

const props = defineProps({
    text: {
        type: [String, Array],
        required: true,
    },
    type: {
        type: String,
        default: "div",
        required: false,
    },
    brClass: {
        type: String,
        default: "",
        required: false,
    },
    splitClass: {
        type: String,
        default: "inline-block",
        required: false,
    },
    customClass: {
        type: String,
        default: "",
        required: false,
    },
    isAutoRevert: {
        type: Boolean,
        default: true,
        required: false,
    },
});

const rootRef = ref(null);
const formatText = useFormat2(props.text);
const {
    animate: doAnimate,
    revert,
    set,
} = useSplitText2(rootRef, {
    splitClass: props.splitClass,
    isAutoRevert: props.isAutoRevert,
});

const animate = (options = {}) => {
    doAnimate(options);
};

defineExpose({ rootRef, animate, revert, set });
</script>

<template>
    <component :is="type" ref="rootRef">
        <template v-for="(part, index) in formatText" :key="part">
            <br
                v-if="part.isLineBreak"
                :class="part.brClass || brClass"
                data-static
                aria-hidden="true"
            />
            <span
                v-else-if="!part.isHtml"
                class="!inline overflow-hidden align-middle"
                :class="customClass"
            >
                {{ part.text }}</span
            >
            <span
                v-else
                class="!inline overflow-hidden align-middle"
                :class="customClass"
                v-html="htmlPurify(part.text)"
                data-static
            ></span>
        </template>
    </component>
</template>
